import script from "./LessonLibraryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonLibraryCard.vue?vue&type=script&setup=true&lang=js"

import "./LessonLibraryCard.vue?vue&type=style&index=0&id=3b493526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b493526"]])

export default __exports__